// extracted by mini-css-extract-plugin
export default {"actions":"ArchivedStandingsSearch_actions__uJMiH","btn":"ArchivedStandingsSearch_btn__U9aSd"};